export default __webpack_public_path__ + "static/1561-f53451fd4055a5b824bd07bb4939c197.gif";